import CustomCard from '../../CustomCard';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param number number: number fot the section (required)
 * @param string title: title fot the section (required)
 * @param string subtitle: subtitle fot the section (required)
 * @param ReactComponentIcon Icon: Icon fot the section (required)
 *
 */
const CustomCardComponent = ({ number, title, subtitle, Icon }) => {

    return (
        <CustomCard classes={"w-100 d-flex flex-column h-100"} classCard={`card-border-8px card-gradient-primary-300-50-general-00`} classContent={"p-16px"}>
            <div className="d-flex align-items-center gap-2 pb-1">
                <div>
                    <div className="d-flex align-items-center circle-number-external">{number}</div>
                </div>
                <p className="title-external">{title}</p>
            </div>
            <p className="subtitle-external">{subtitle}</p>
            <div className="h-120px mt-2 d-flex justify-content-center align-items-center">
                <Icon className="w-100 h-100" />
            </div>
        </CustomCard>
    )

}

export default CustomCardComponent
